

























































































import { Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { BrCatalog, BrCatalogTreeFragmentDoc, ChartDashboard } from '@/module/graphql'
import { ElTree } from 'element-ui/types/tree'
import gql from 'graphql-tag'
import _ from 'lodash'
import { submitMutation } from '@/module/common/util/graphql-util'
import LocalDbDao from '@/module/common/local-db-dao'
import Vue from 'vue'
import EventBus from '@/d2admin/plugin/event/event-bus'

type BrCatalogWrapper = BrCatalog & {
  children?: BrCatalogWrapper[]
  parent?: BrCatalogWrapper
  entity: ChartDashboard
}
@Component
export default class CmpBrCatalog extends Vue {
  @Ref() private readonly elTree!: ElTree<any, any> | any
  @Ref() private readonly elContextMenu!: any
  @Ref() readonly brCatalogFormRef!: any

  @Prop() readonly editable: boolean
  @Prop({ default: 'id' }) readonly nodeKey: string
  @Prop() readonly lightEditable: boolean
  @Prop({ default: true }) readonly singleRoot: boolean
  @Prop({ default: false }) readonly hasFooter: boolean
  @Prop({ default: false }) readonly fetchEntities: boolean
  @Prop({ default: false }) readonly countEntity: boolean
  @Prop({ default: false }) readonly showCheckBox: boolean
  @Prop({ default: true }) readonly createUndefinedCatalog: boolean
  @Prop({ default: false }) readonly ignoreEmptyCatalog: boolean
  @Prop({ required: true }) readonly modelName: string
  @Prop() readonly catalogEditPermissionKey: string
  @Prop() readonly treeId: string
  @Prop() readonly filterRootCatalogs: string[]
  @Prop() readonly defaultCheckedKeys: string[]

  private mTreeData: BrCatalogWrapper[] = []
  private mFilterText: string = ''
  private mExpandedIds: string[] = ['-1']
  private mExpandedIdsCache: string[] = ['-1']

  private mContextMenuCatalog: BrCatalogWrapper = null

  private mCatalogDialogVisible = false
  private mEditingBrCatalog: BrCatalog = null
  private mLoading = false
  private mSortField:string = 'name'
  private mSortFieldIcon:string = 'fa fa-font'
  private mSortOrderIcon:string = 'fa fa-long-arrow-up'

  get currentCatalog() {
    let catalog = this.mContextMenuCatalog
    if (catalog?.entity) catalog = catalog.parent as BrCatalogWrapper
    return (catalog?.id !== '-1' && catalog?.id !== '-2') ? catalog : null
  }

  get currentEntity() {
    return this.mContextMenuCatalog?.entity || null
  }

  get menuAddCatalogVisibility() {
    return this.editable &&
      (!this.catalogEditPermissionKey || this.$perm(this.catalogEditPermissionKey)) &&
      ((this.mContextMenuCatalog && !this.mContextMenuCatalog.entity && this.mContextMenuCatalog.id !== '-2') || !this.mContextMenuCatalog)
  }

  /* 修改目录右键菜单 */
  get menuEditCatalogVisibility() {
    return this.editable &&
      (!this.catalogEditPermissionKey || this.$perm(this.catalogEditPermissionKey)) &&
      this.mContextMenuCatalog &&
      !this.mContextMenuCatalog.entity && // 不是表格
      this.mContextMenuCatalog.id !== '-1' && // 不是全部
      this.mContextMenuCatalog.id !== '-2' // 不是未分类
  }

  created() {
    if (this.catalogEditPermissionKey) {
      LocalDbDao.prefetchPermissions([this.catalogEditPermissionKey])
    }

    this.loadData(false)
    EventBus.$on('expand-node', this.onExpandNode)
    EventBus.$on('refresh-br-catalog', this.refreshCatalog)
  }

  destroyed() {
    EventBus.$off('expand-node', this.onExpandNode)
    EventBus.$off('refresh-br-catalog', this.refreshCatalog)
  }
  refreshCatalog() {
    this.loadData(true, true)
  }

  onExpandNode(nodeKey: string) {
    this.elTree.getNode(nodeKey)?.parent.expand(null, true)
    this.elTree.setCurrentKey(nodeKey)
  }
  public getCheckedNodes() {
    return this.elTree.getCheckedNodes()
  }

  public getNodeData(nodeData: any) {
    return this.elTree.getNode(nodeData)
  }

  public loadData(flushCache = false, keepExpanded = false) {
    this.mLoading = true
    this.$apollo.query({
      query: gql`query ($filterRootCatalogs: [String]) {
        brCatalogs(flushCache: ${flushCache},
                   fetchEntities: ${this.fetchEntities},
                   countEntity: ${this.countEntity},
                   ignoreEmptyCatalog: ${this.ignoreEmptyCatalog},
                   singleRoot: ${this.singleRoot},
                   createUndefinedCatalog: ${this.createUndefinedCatalog},
                   modelName: "${this.modelName}",
                   filterRootCatalogs: $filterRootCatalogs) {
          ...brCatalogTree
        }
      }
      ${BrCatalogTreeFragmentDoc}`,
      variables: {
        filterRootCatalogs: this.filterRootCatalogs
      }
    }).then(data => {
      this.mLoading = false
      if (this.fetchEntities) {
        data.data.brCatalogs.forEach(this.setCatalogEntityChildren)
      }
      this.mTreeData = data.data.brCatalogs
      this.$emit('tree-loaded', this.mTreeData)
      this.sortTree()
    })
  }

  private setCatalogEntityChildren(catalog: BrCatalogWrapper) {
    if (!catalog.children) {
      catalog.children = []
    }
    (catalog.entities || []).forEach((entity: any) => {
      catalog.children.push({
        id: entity.id ? entity.id : (entity.code ? entity.code : entity.name),
        name: entity.name,
        updatedAt: entity.updatedAt,
        parent: catalog,
        entity: entity
      } as BrCatalogWrapper)
    })
    catalog.children.forEach(this.setCatalogEntityChildren)
  }

  @Watch('mFilterText')
  private onFilterTextChanged(val: string) {
    this.elTree.filter(val)
  }

  private filterNode(value: string, catalog: BrCatalog) {
    if (!value) return true
    return catalog.name!.toLocaleLowerCase().indexOf(value.toLocaleLowerCase()) >= 0
  }

  private onClick(catalog: BrCatalogWrapper) {
    this.elContextMenu.hide()
    if (catalog.entity) {
      this.$emit('click-entity', catalog.entity)
    } else {
      this.$emit('click-catalog', { catalog: catalog, pathIds: this.getPathIds(catalog) })
    }
  }

  onCheckChange() {
    this.$emit('check-change', this.elTree.getCheckedNodes())
  }

  getPathIds(catalog: BrCatalog) {
    const ids: string[] = []
    ids.push(catalog.id)
    catalog.children.forEach(child => {
      ids.push(...this.getPathIds(child))
    })
    return ids
  }

  toggleSortField() {
    if (this.mSortField === 'updatedAt') {
      this.mSortField = 'name'
      this.mSortFieldIcon = 'fa fa-font'
    } else {
      this.mSortField = 'updatedAt'
      this.mSortFieldIcon = 'fa fa-clock-o'
    }
    this.sortTree()
  }

  toggleSortOrder() {
    if (this.mSortOrderIcon === 'fa fa-long-arrow-down') {
      this.mSortOrderIcon = 'fa fa-long-arrow-up'
    } else {
      this.mSortOrderIcon = 'fa fa-long-arrow-down'
    }
    this.sortTree()
  }

  sortTree() {
    const root = { children: this.mTreeData } as BrCatalogWrapper
    this.sortChildren(root)
    this.mTreeData = root.children
    this.mTreeData.forEach(node => this.sortChildren(node))
    const clone = _.cloneDeep(this.mTreeData)
    this.mTreeData = []
    this.$nextTick(() => {
      this.mTreeData = clone
      this.mExpandedIds = _.cloneDeep(this.mExpandedIdsCache)
    })
    setTimeout(() => {
      this.elTree.filter(this.mFilterText)
    }, 100)
  }

  sortChildren(catalog: BrCatalog) {
    if (_.isEmpty(catalog.children)) return
    catalog.children = _.orderBy(catalog.children, [(c: BrCatalog) => {
      if (c.id === '-2') return null
      return _.get(c, this.mSortField)
    }], this.mSortOrderIcon === 'fa fa-long-arrow-down' ? 'desc' : 'asc')
    if (catalog.children[0].id === '-2') {
      catalog.children.push(catalog.children[0])
      catalog.children.splice(0, 1)
    }
    catalog.children.forEach(child => this.sortChildren(child))
  }

  onContextMenuHide() {
    this.mContextMenuCatalog = null
  }
  private onContextMenuClick(e: MouseEvent, catalog: BrCatalogWrapper) {
    this.elContextMenu.hide()
    this.mContextMenuCatalog = catalog
    this.$emit('currentEntityChanged', catalog.entity)
    if (catalog.entity) {
      this.$emit('context-entity-changed', catalog.entity)
    } else {
      this.$emit('context-catalog-changed', catalog)
    }
    this.elContextMenu.handleReferenceContextmenu(e)
  }

  onNodeExpand(data: any, node: any, comp: any) {
    this.mExpandedIdsCache.push(data.id)
  }

  onNodeCollapse(data: any, node: any, comp: any) {
    let idx = _.findIndex(this.mExpandedIdsCache, nodeKey => nodeKey === data.id)
    if (idx !== -1) {
      this.mExpandedIdsCache.splice(idx, 1)
    }
  }

  async allowDrop(draggingNode: any, dropNode: any, type: any) {
    return this.editable &&
      this.$perm('MdTableCatalogEdit') &&
      dropNode.data.id !== '-1' && dropNode.data.id !== '-2'
  }

  allowDrag(node: any) {
    return node.data.id !== '-1' && node.data.id !== '-2' && !node.data.chartDashboard
  }

  nodeDrop(draggingNode: any, dropNode: any, dropType: string, ev: any) {
    let postData: any = {
      catalogId: draggingNode.data.id
    }
    if (dropType === 'inner') {
      postData.parentId = dropNode.data.id
      postData.newSeq = dropNode.childNodes.length
    } else {
      let draggingNodeDataParent = draggingNode.data.parent ? draggingNode.data.parent : { id: '-1' }
      let dropNodeDataParent = dropNode.data.parent ? dropNode.data.parent : { id: '-1' }
      let idx = _.findIndex(dropNode.parent.childNodes, (child: any) => child.data.id === dropNode.data.id)
      if (draggingNodeDataParent.id !== dropNodeDataParent.id) {
        postData.parentId = dropNodeDataParent.id
      }
      postData.newSeq = idx
    }
    submitMutation(this, {
      mutationOptions: {
        mutation: gql`mutation moveBrCatalog($catalogId: ID!, $parentId: ID, $newSeq: Int!) {
            moveBrCatalog(catalogId: $catalogId, parentId: $parentId, newSeq: $newSeq)
        }`,
        variables: postData
      },
      ignoreWarning: false
    })
  }

  addCatalog() {
    this.mCatalogDialogVisible = true
    this.mEditingBrCatalog = {
      name: '',
      parent: this.currentCatalog?.id
    } as any
    this.elContextMenu.hide()
  }

  editCatalog() {
    this.mCatalogDialogVisible = true
    this.mEditingBrCatalog = _.cloneDeep(this.currentCatalog)
  }

  deleteCatalog() {
    const deletedId = this.currentCatalog.id
    this.elContextMenu.hide()
    const h = this.$createElement
    const msg = `确认删除目录${this.currentCatalog?.name}，以及该目录下面的子目录?该操作将把目录下的数据归到未定义下面`
    const tree = h('el-tree', {
      props: {
        data: [this.currentCatalog],
        defaultExpandAll: true,
        nodeKey: 'id',
        props: {
          children: 'children'
        }
      },
      scopedSlots: {
        default: props => {
          if (!props.data.entity) return props.data.name
          return h('span', {
            attrs: {
              class: 'text-primary'
            }
          }, props.data.entity.name)
        }
      }
    })
    this.$msgbox({
      message: h('div', [
        h('span', {
          attrs: {
            class: 'text-warning'
          }
        }, msg),
        tree
      ]),
      title: '提示',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      submitMutation(this, {
        mutationOptions: {
          mutation: gql`mutation deleteBrCatalog($id: ID!) {
              deleteBrCatalog(id: $id)
          }`,
          variables: {
            id: deletedId
          }
        },
        ignoreWarning: false
      }).then(() => {
        this.$message({
          message: '删除成功', type: 'success', showClose: true
        })
        this.loadData(false, true)
        this.$emit('catalog-deleted')
      })
    })
  }

  saveCatalog() {
    this.brCatalogFormRef.validate((valid: boolean) => {
      if (valid) {
        if (!this.mEditingBrCatalog.id) {
          submitMutation(this, {
            mutationOptions: {
              mutation: gql`mutation createBrCatalog($name: String!, $parentId: ID, $modelName: String!) {
                  createBrCatalog(name: $name, parentId: $parentId, modelName: $modelName) { name, id }
              }`,
              variables: {
                name: this.mEditingBrCatalog.name,
                parentId: this.mEditingBrCatalog.parent,
                modelName: this.modelName
              }
            },
            ignoreWarning: false
          }).then(data => {
            if (!data) return
            this.$message({
              message: '创建成功', type: 'success', showClose: true
            })
            this.mCatalogDialogVisible = false
            this.$emitToGlobal('refresh-br-catalog')
          })
        } else {
          submitMutation(this, {
            mutationOptions: {
              mutation: gql`mutation updateBrCatalog($id: ID!, $ver:Int!, $name: String!) {
                  updateBrCatalog(id: $id, ver: $ver, name: $name) { id name ver }
              }`,
              variables: {
                id: this.mEditingBrCatalog.id,
                ver: this.mEditingBrCatalog.ver,
                name: this.mEditingBrCatalog.name
              }
            },
            ignoreWarning: false
          }).then(data => {
            if (!data) return
            this.$message({
              message: '修改成功', type: 'success', showClose: true
            })
            this.mCatalogDialogVisible = false
            this.$emitToGlobal('refresh-br-catalog')
          })
        }
      } else {
        this.$message({
          message: '提交信息有误,请修正', type: 'error', showClose: true
        })
      }
    })
  }
}
